import { DocumentIcon } from '@heroicons/react/24/solid';
import React from 'react';

import Icon, { IconVariant } from 'components/Icon/Icon';
import { FileType } from 'enums';

interface AttachmentPreviewProps {
  file: Blob;
}

const AttachmentPreview = ({ file }: AttachmentPreviewProps) => {
  const fileType = FileType[file.type as keyof typeof FileType] || 'FILE';
  const fileSize = parseFloat(`${file.size / (1024 * 1024)}`).toFixed(2);

  return (
    <div className="flex w-fit min-w-[16rem] rounded-lg border border-kira-slate-200">
      <div className="flex justify-center self-center bg-kira-slate-100">
        <Icon icon={<DocumentIcon />} variant={IconVariant.LARGE} />
      </div>
      <div className="mx-4 self-center">
        <p className="prose-body-md-reg font-medium text-kira-slate-900">
          {file.name}
        </p>
        <p className="prose-body-sm-reg text-kira-slate-700">
          {`${fileType} • ${fileSize}MB`}
        </p>
      </div>
    </div>
  );
};
export default AttachmentPreview;
